module.exports = __webpack_public_path__ + "assets/images/reg_type_hint@2x.png";